import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createLeafStockItem,
  getAllLeafStocksItems,
  getDataForEdit,
  deleteLeafStockItem,
  getBillListForVendor,
  getDataForAfterBill,
  adjustLeafStockItem,
} from "../../store/LeafStock/LeafStockSliceApi";

import {
  getAllVendorItems,
  getLeafListItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { leafStockSliceAction } from "../../store/LeafStock/LeafStockSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsLeafStocks } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsLeafStocks } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialLeafStockFormData } from "../../ConstantData/InitialData";
//imporint form data error

//for only adjusted form
import { ErrorLeafStockFormData } from "../../ConstantData/ErrorOption";
import { adjustedFormLeafStock } from "../../ConstantData/AdjustedFormOption";
import { InitialAdjustData } from "../../ConstantData/AdjustInitialData";

function LeafStock() {
  const [showOtherFormBtn, setShowOtherFormBtn] = useState(false); //for only adjust

  const [adjustInitialData, setAdjustInitialData] = useState(InitialAdjustData);

  let newFormOptionsLeafStock = JSON.parse(
    JSON.stringify(AddMoreFormOptionsLeafStocks)
  );

  let newFormOptionsLeafStockText = JSON.parse(
    JSON.stringify(FormOptionsLeafStocks)
  );
  let newAdjustedFormLeafStock = JSON.parse(
    JSON.stringify(adjustedFormLeafStock)
  );
  // let billDataList = useSelector((state) => state.LeafStock.billDataList);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllLeafStocksItems());
    // dispatch(getAllVendorItems());
    // dispatch(getLeafListItems());
  }, []);

  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const leafStockList = useSelector((state) => state.leafstock.leafStockList);

  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.leafstock.initialData
  );
  //for normal duplicate form input data initilization
  let InitialFormDuplicateDataStore = useSelector(
    (state) => state.leafstock.initialDuplicateData
  );

  const leafStockEditData = useSelector((state) => state.leafstock.dataEdit);
  let leafStockFormError = useSelector((state) => state.leafstock.errorData);

  let isError = useSelector((state) => state.leafstock.isError);
  leafStockFormError = {
    ...ErrorLeafStockFormData,
    ...leafStockFormError,
  };
  const vendorList = useSelector((state) => state.applevel.vendorList);
  const leafList = useSelector((state) => state.applevel.leafList);

  const billList = useSelector((state) => state.leafstock.billList);

  function addOptionForSelectFieldDuplicate(
    FormOption,
    list,
    optionName,
    type
  ) {
    if (type === "duplicate") {
      newFormOptionsLeafStock = FormOption.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    } else {
      newAdjustedFormLeafStock = adjustedFormLeafStock.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    }
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsLeafStockText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (vendorList.length > 0) {
    // to chage subquality option coming from server4
    addOptionForSelectField(newFormOptionsLeafStockText, vendorList, "Vendor");
  }

  if (leafList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      newFormOptionsLeafStockText,
      leafList,
      "Leaf Type",
      "duplicate"
    );
  }

  if (billList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      adjustedFormLeafStock,
      billList,
      "Bill Number",
      "adjusted"
    );
  } else {
    addOptionForSelectFieldDuplicate(
      adjustedFormLeafStock,
      [],
      "Bill Number",
      "adjusted"
    );
  }

  const setDataForAdjust = (type) => {
    if (vendorList.length > 0) {
      addOptionForSelectFieldDuplicate(
        adjustedFormLeafStock,
        vendorList,
        "Vendor",
        "adjusted"
      );
    }
  };

  const inputAdjustHandler = (name, value) => {
    //only for adjust not need for all

    const formData = JSON.parse(JSON.stringify(adjustInitialData)); //deep copy
    if (name === "bill_number") {
      setShowOtherFormBtn((prevState) => !prevState);
      // dispatch(getDataForAfterBill(value.value));
    }
    // if (name === "vendor") dispatch(getBillListForVendor(value.value));
    formData[name] = value;
    setAdjustInitialData(formData);
  };

  const headTitleLabel = headTitle(FormOptionsLeafStocks, [
    "Leaf Type",
    "Quantity",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialLeafStockFormData}
      getDataForEdit={getDataForEdit}
      delteFun={deleteLeafStockItem}
      createFun={createLeafStockItem} //create function coming from store
      FormOptions={newFormOptionsLeafStockText}
      // NewFormOptions={newFormOptionsLeafStock}
      OptionName="Create Leaf Stock"
      OptionNameList="Leaf Stock"
      generalList={leafList}
      headTitle={headTitleLabel}
      EditData={leafStockEditData}
      isError={isError}
      ErrorData={leafStockFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={leafStockSliceAction.setErrorData}
      generalModuleList={vendorList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={false}
      extraButtonText={"Add Leaf"}
      FormStyle={"!w-[60%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={false} // to create second button to add extra form
      isSuccess={isSuccess}
      needAdjust={true} //it is used if there is no edit but need adjust
      adjustedFormStock={adjustedFormLeafStock} //it is used if there is no edit but need adjust
      setDataForAdjust={setDataForAdjust}
      inputAdjustHandler={inputAdjustHandler} //it is used if there is no edit but need adjust
      InitialAdjustData={adjustInitialData} //it is used if there is no edit but need adjust
      listForLength={{ billList }}
      showOtherFormBtn={showOtherFormBtn} // //it is used if there is no edit but need adjust
      createAdjust={adjustLeafStockItem}
      notShowEditBtn={true} //use when you dont need edit btn
    />
  );
}

export default LeafStock;
